import React, { useEffect} from "react";
import { useForm} from "react-hook-form";
import { useLocation  } from "react-router-dom";
import Header from "../components/Header";
import { useAxios } from "../services/useAxios";
import {alert, confirm} from "../components/MegConfirmAlert";
import { useTranslation } from 'react-i18next';

export default function ProductQnAWrite(props){
    const { t } = useTranslation();

    const {register, handleSubmit, formState, setValue }= useForm();
    const{errors} = formState;
    const [request] = useAxios();
    
    const onSubmit = async data=> {
        if(data.nttSn){
            data.bbsSn = 2     
            data.aditfield5 = 'INQ001'
            data.othbcAt = data.othbcAt?"N":"Y"       
            const response = await request.post("/app/mypage/procInqryNttModifyAPI", data);
    
            if(response.data.resultCode === 200){
                await alert(response.data.resultMessage);
                window.location.reload();            
            }else{
                alert(response.data.resultMessage);
            }
        }else{
            data.bbsSn = 2
            data.aditfield1 = props.goodsSn
            data.aditfield5 = 'INQ001'
            data.othbcAt = data.othbcAt?"N":"Y"
            console.log(data)
            
            const response = await request.post("/app/mypage/procInqryNttRegistAPI", data);

            if(response.data.resultCode === 200){
                await alert(response.data.resultMessage);
                window.location.reload();            
            }else{
                alert(response.data.resultMessage);
            }
        }
        
    }

    useEffect(() => {
        if(props.dataInfo.nttSn){
            console.log(props.dataInfo)
            setValue("nttSn",props.dataInfo.nttSn)
            setValue("nttSj",props.dataInfo.nttSj)
            setValue("nttCn",props.dataInfo.nttCn)
            setValue("othbcAt",props.dataInfo.othbcAt==="N")
        }
      }, []);

    return (
        <div className={props.modal?'modalPage':'justPage'}>
            <Header type={props.modal?'modal':'black'} closeFn={props.closeFn} pageTitle={t(`Message.goods_inqry_regist_title`)} />

            <div className="formWr">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ul className="contUl">
                        <li>
                            <p className="tit">{t(`Message.goods_inqry_regist_sj`)}</p>
                            <input type="text" placeholder={t(`Message.goods_inqry_regist_sj_error_text`)} {...register("nttSj", { required:"필수 응답 항목입니다."})}/>
                            {errors.nttSj && <p role="alert" className="alertRed">{errors.nttSj.message}</p>}
                        </li>
                        <li>
                            <p className="tit">{t(`Message.goods_inqry_regist_cn`)}</p>
                            <textarea placeholder={t(`Message.goods_inqry_regist_cn_error_text`)} {...register("nttCn", { required:"필수 응답 항목입니다."})} />
                            {errors.nttCn && <p role="alert" className="alertRed">{errors.nttCn.message}</p>}
                        </li>
                        <li>
                        <div className="chkWr pb20">
                            <input type="checkbox" id="othbcAt" {...register("othbcAt", {})}/>
                            <label htmlFor="othbcAt">{t(`Message.goods_inqry_regist_secret_reg`)}</label>
                        </div>
                        </li>
                    </ul>

                    <button type="submit" className="floatBtn">{t(`Message.goods_inqry_regist_reg`)}</button>  
                </form>
            </div>
        </div>
    );  
};